import { render, staticRenderFns } from "./StatisticsReduce.vue?vue&type=template&id=54797d06&scoped=true"
import script from "./StatisticsReduce.vue?vue&type=script&lang=js"
export * from "./StatisticsReduce.vue?vue&type=script&lang=js"
import style0 from "./StatisticsReduce.vue?vue&type=style&index=0&id=54797d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54797d06",
  null
  
)

export default component.exports